export default __webpack_public_path__ + "static/media/bkg.239de1e1.mp4";